import { CandidateFormPageSSR } from '@/p/views/candidate-form/candidate-form.page.ssr';
export default CandidateFormPageSSR;
